module.exports = __webpack_public_path__ + "img/5-min.09a2d8a9.jpg";